export default __webpack_public_path__ + "static/media/mobile-settings.e4c7e4f1.png";